import React from 'react';
import WatchReview from '../watchReview'


function Ichi(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/fCzrZijK7GA" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss manga turned movie 'Ichi The Killer'. This one...is weird...."
            />
        )
    }   

export default Ichi;